/**
 * 웹뷰(`ably://webview?url=...`)로만 열 수 있는(웹 미지원) 경로 판정.
 *
 * `convertDeeplinkToWebLink` 에서 떼어 둔 이유: 판정 자체는 순수 문자열 규칙인데
 * `convertDeeplinkToWebLink` 는 `resolveWebURL` → 네이티브 `LocalStorageBridge` →
 * `react-native` 를 끌고 온다. 순수 로직만 필요한 쪽(`resolveWebviewDeeplinkUrl`)이
 * 그 체인까지 물면 react-native 를 로드할 수 없는 환경(shared 의 jest 유닛테스트는
 * node preset 이라 node_modules 를 변환하지 않는다)에서 모듈 로딩부터 깨진다.
 *
 * ⚠️ 이 파일은 순수하게 유지할 것. 여기로 import 를 추가하면 위 체인이 되살아난다.
 */

/** 웹뷰에서 열리지만 웹에서는 지원하지 않는 경로 패턴 (ably://webview?url=...) */
const NATIVE_ONLY_WEBVIEW_PATTERNS: RegExp[] = [
  /^\/ai-studio/,
  /^\/content\/fitting-rooms/,
  /^\/content\/ai-profile/,
  /^\/goods\/\d+\/reviews\/photo/,
];

/** 웹뷰로만 열 수 있는(웹 미지원) 경로인지. 웹에서는 앱 다운로드 유도로 이어진다. */
export const isNativeOnlyWebviewPath = (path: string): boolean =>
  NATIVE_ONLY_WEBVIEW_PATTERNS.some(pattern => pattern.test(path));
